/**
 * The my-orders v2 rollout gate.
 *
 * Same mechanism as payments — the build contains v2 AND the terminal's `branchId` or
 * `accountUUID` is listed — and the same matcher, imported rather than copied. Every web terminal
 * the list does not name stays on v1, and an entry is a reviewed code change; removing
 * the entry is the rollback. A development or QA build turns it on with the rollout override
 * (`myOrdersV2Override`, the rollout panel's "My Orders v2"), which replaced the temporary
 * `ORDERS_V2_FORCED_ON` on 2026-10-09 (the user, by popup).
 *
 * Only the WEB shell reads this. Mobile has no gate by design: its cutover commit is the switch
 * and `git revert` is the rollback.
 */
import { matchesAllowlist, type V2Allowlist } from "@rista/payments/engine/config";

import { devOverride } from "../../utils/rolloutOverride";

export const ORDERS_V2_ALLOWLIST: V2Allowlist = {
  branchIds: [],
  accountUUIDs: ["6a963a5b-a99a-442b-a944-cd96c7930a11"],
};

export const ordersV2Enabled = (businessData: any) =>
  matchesAllowlist(businessData, ORDERS_V2_ALLOWLIST) || devOverride("myOrdersV2Override");
